module.exports = __webpack_public_path__ + "static/assets/72e455e9384497604e1d9d6dd00478bc.gif";